import React, { useState } from "react";

const CountrySelector = ({ onSelectCity }) => {
  const [selectedCountry, setSelectedCountry] = useState(null);

  const countries = {
    // korea: {
    //   name: '한국',
    //   flag: '🇰🇷',
    //   image: '/assets/cities/korea_seoul.webp',
    //   credit: 'Seoul Skyline Night 2018 (CC0) – Wikimedia Commons',
    //   cities: [
    //     {
    //       name: '서울',
    //       lat: 37.5665,
    //       lng: 126.9780,
    //       zoom: 12,
    //       bounds: { north: 37.72, south: 37.45, east: 127.15, west: 126.80 },
    //       image: '/assets/cities/korea_seoul.webp',
    //       credit: 'Seoul Skyline Night 2018 (CC0) – Wikimedia Commons'
    //     },
    //     {
    //       name: '부산',
    //       lat: 35.1796,
    //       lng: 129.0756,
    //       zoom: 12,
    //       bounds: { north: 35.35, south: 34.90, east: 129.30, west: 128.70 },
    //       image: '/assets/cities/korea_busan.webp',
    //       credit: 'Korea-Busan-Gwangan.Bridge-04 (CC BY 2.0) – Wikimedia Commons'
    //     },
    //     {
    //       name: '제주',
    //       lat: 33.4996,
    //       lng: 126.5312,
    //       zoom: 11,
    //       bounds: { north: 33.62, south: 33.20, east: 126.95, west: 126.00 },
    //       image: '/assets/cities/korea_jeju.webp',
    //       credit: 'Jeju - Seongsan Ilchulbong 2 (CC BY-SA 3.0) – Wikimedia Commons'
    //     },
    //     {
    //       name: '대구',
    //       lat: 35.8714,
    //       lng: 128.6014,
    //       zoom: 12,
    //       bounds: { north: 36.00, south: 35.75, east: 128.75, west: 128.45 },
    //       image: '/assets/cities/korea_daegu.webp',
    //       credit: '11월 83번째 (CC BY 4.0) – Wikimedia Commons'
    //     },
    //     {
    //       name: '인천',
    //       lat: 37.4563,
    //       lng: 126.7052,
    //       zoom: 12,
    //       bounds: { north: 37.65, south: 37.20, east: 126.90, west: 126.50 },
    //       image: '/assets/cities/korea_incheon.webp',
    //       credit: 'Incheon bridge 2009 (CC BY 2.0) – Wikimedia Commons'
    //     }
    //   ]
    // },
    japan: {
      name: '일본',
      flag: '🇯🇵',
      image: '/assets/cities/japan_tokyo.webp',
      credit: 'Tokyo-skyline (CC BY-SA 2.0 DE) – Wikimedia Commons',
      cities: [
        {
          name: '도쿄',
          lat: 35.6762,
          lng: 139.6503,
          zoom: 12,
          bounds: { north: 35.80, south: 35.55, east: 139.85, west: 139.45 },
          image: '/assets/cities/japan_tokyo.webp',
          credit: 'Tokyo-skyline (CC BY-SA 2.0 DE) – Wikimedia Commons'
        },
        {
          name: '오사카',
          lat: 34.6937,
          lng: 135.5023,
          zoom: 12,
          bounds: { north: 34.80, south: 34.60, east: 135.65, west: 135.35 },
          image: '/assets/cities/japan_osaka.webp',
          credit: 'Dotonbori, Osaka, at night, November 2016 (CC BY-SA 4.0) – Wikimedia Commons'
        },
        {
          name: '교토',
          lat: 35.0116,
          lng: 135.7681,
          zoom: 12,
          bounds: { north: 35.10, south: 34.90, east: 135.90, west: 135.60 },
          image: '/assets/cities/japan_kyoto.webp',
          credit: 'Kiyomizu dera in Kyoto by night (CC license–see file page) – Wikimedia Commons'
        },
        {
          name: '후쿠오카',
          lat: 33.5904,
          lng: 130.4017,
          zoom: 12,
          bounds: { north: 33.75, south: 33.45, east: 130.55, west: 130.20 },
          image: '/assets/cities/japan_fukuoka.webp',
          credit: 'Fukuoka Tower from south side (CC BY-SA 4.0) – Wikimedia Commons'
        },
        {
          name: '삿포로',
          lat: 43.0642,
          lng: 141.3469,
          zoom: 12,
          bounds: { north: 43.20, south: 42.90, east: 141.50, west: 141.20 },
          image: '/assets/cities/japan_sapporo.webp',
          credit: 'Sapporo TV tower-20091013-RM-162316 (CC BY-SA 4.0) – Wikimedia Commons'
        }
      ]
    },
    china: {
      name: '중국',
      flag: '🇨🇳',
      image: '/assets/cities/china_beijing.webp',
      credit: 'Beijing skyline at night (CC–see file page) – Wikimedia Commons',
      cities: [
        {
          name: '베이징',
          lat: 39.9042,
          lng: 116.4074,
          zoom: 11,
          bounds: { north: 40.10, south: 39.70, east: 116.60, west: 116.20 },
          image: '/assets/cities/china_beijing.webp',
          credit: 'Beijing skyline at night (CC–see file page) – Wikimedia Commons'
        },
        {
          name: '상하이',
          lat: 31.2304,
          lng: 121.4737,
          zoom: 11,
          bounds: { north: 31.40, south: 31.10, east: 121.65, west: 121.30 },
          image: '/assets/cities/china_shanghai.webp',
          credit: 'Shanghai - Pudong Skyline - 0010 (CC BY-SA 3.0) – Wikimedia Commons'
        },
        {
          name: '광저우',
          lat: 23.1291,
          lng: 113.2644,
          zoom: 11,
          bounds: { north: 23.30, south: 22.95, east: 113.45, west: 113.05 },
          image: '/assets/cities/china_guangzhou.webp',
          credit: 'Canton Tower In The Evening (CC BY-SA 3.0) – Wikimedia Commons'
        },
        {
          name: '청두',
          lat: 30.5728,
          lng: 104.0668,
          zoom: 11,
          bounds: { north: 30.80, south: 30.35, east: 104.30, west: 103.85 },
          image: '/assets/cities/china_chengdu.webp',
          credit: 'Chengdu - Tianfu Square - panoramio (CC BY 3.0) – Wikimedia Commons'
        },
        {
          name: '시안',
          lat: 34.2658,
          lng: 108.9541,
          zoom: 11,
          bounds: { north: 34.45, south: 34.10, east: 109.15, west: 108.75 },
          image: '/assets/cities/china_xian.webp',
          credit: "Xi'an bell tower (Public domain) – Wikimedia Commons"
        }
      ]
    },
    taiwan: {
      name: '대만',
      flag: '🇹🇼',
      image: '/assets/cities/taiwan_taipei.webp',
      credit: 'Taipei night view with 101 (CC BY-SA 2.0) – Wikimedia Commons',
      cities: [
        {
          name: '타이베이',
          lat: 25.0330,
          lng: 121.5654,
          zoom: 12,
          bounds: { north: 25.15, south: 24.95, east: 121.70, west: 121.45 },
          image: '/assets/cities/taiwan_taipei.webp',
          credit: 'Taipei night view with 101 (CC BY-SA 2.0) – Wikimedia Commons'
        },
        {
          name: '타이중',
          lat: 24.1477,
          lng: 120.6736,
          zoom: 12,
          bounds: { north: 24.25, south: 24.05, east: 120.80, west: 120.55 },
          image: '/assets/cities/taiwan_taichung.webp',
          credit: 'National Taichung Theater 2019 (CC BY 2.0) – Wikimedia Commons'
        },
        {
          name: '타이난',
          lat: 22.9997,
          lng: 120.2270,
          zoom: 12,
          bounds: { north: 23.10, south: 22.90, east: 120.30, west: 120.10 },
          image: '/assets/cities/taiwan_tainan.webp',
          credit: 'Chihkan Tower night (CC BY-SA 3.0) – Wikimedia Commons'
        },
        {
          name: '가오슝',
          lat: 22.6273,
          lng: 120.3014,
          zoom: 12,
          bounds: { north: 22.75, south: 22.50, east: 120.45, west: 120.15 },
          image: '/assets/cities/taiwan_kaohsiung.webp',
          credit: 'Kaohsiung 85 Building (CC BY-SA 3.0) – Wikimedia Commons'
        },
        {
          name: '화롄',
          lat: 23.9871,
          lng: 121.6015,
          zoom: 12,
          bounds: { north: 24.20, south: 23.80, east: 121.80, west: 121.40 },
          image: '/assets/cities/taiwan_hualien.webp',
          credit: 'Taroko Gorge (CC BY-SA 3.0) – Wikimedia Commons'
        }
      ]
    },
    vietnam: {
      name: '베트남',
      flag: '🇻🇳',
      image: '/assets/cities/vietnam_hanoi.webp',
      credit: 'Hoan Kiem Lake at night 1 (CC BY-SA 4.0) – Wikimedia Commons',
      cities: [
        {
          name: '하노이',
          lat: 21.0285,
          lng: 105.8542,
          zoom: 12,
          bounds: { north: 21.15, south: 20.90, east: 106.00, west: 105.70 },
          image: '/assets/cities/vietnam_hanoi.webp',
          credit: 'Hoan Kiem Lake at night 1 (CC BY-SA 4.0) – Wikimedia Commons'
        },
        {
          name: '다낭',
          lat: 15.9000,
          lng: 108.0500,
          zoom: 11,
          bounds: {
                north: 16.30,
                south: 15.65,
                east: 108.55,
                west: 107.90
          },
          image: '/assets/cities/vietnam_danang.webp',
          credit: 'Dragon Bridge, Da Nang at night - 20230819 (CC BY-SA 4.0) – Wikimedia Commons'
        },
        {
          name: '호치민',
          lat: 10.8231,
          lng: 106.6297,
          zoom: 12,
          bounds: { north: 10.95, south: 10.70, east: 106.80, west: 106.50 },
          image: '/assets/cities/vietnam_hcmc.webp',
          credit: 'Notre-Dame Cathedral Basilica of Saigon (CC0) – Wikimedia Commons'
        },
        {
          name: '나트랑',
          lat: 12.2388,
          lng: 109.1967,
          zoom: 12,
          bounds: { north: 12.40, south: 12.10, east: 109.30, west: 109.05 },
          image: '/assets/cities/vietnam_nhatrang.webp',
          credit: 'Tháp Trầm Hương, Nha Trang - panoramio (CC BY-SA 3.0) – Wikimedia Commons'
        },
        {
          name: '하롱',
          lat: 20.9101,
          lng: 107.1839,
          zoom: 12,
          bounds: { north: 21.05, south: 20.75, east: 107.35, west: 107.00 },
          image: '/assets/cities/vietnam_halong.webp',
          credit: 'Halong Bay in Vietnam (CC BY-SA 3.0) – Wikimedia Commons'
        }
      ]
    },
    thailand: {
      name: '태국',
      flag: '🇹🇭',
      image: '/assets/cities/thailand_bangkok.webp',
      credit: 'Wat Arun night (CC license–see file page) – Wikimedia Commons',
      cities: [
        {
          name: '방콕',
          lat: 13.7563,
          lng: 100.5018,
          zoom: 12,
          bounds: { north: 13.95, south: 13.60, east: 100.70, west: 100.35 },
          image: '/assets/cities/thailand_bangkok.webp',
          credit: 'Wat Arun night (CC license–see file page) – Wikimedia Commons'
        },
        {
          name: '치앙마이',
          lat: 18.7883,
          lng: 98.9853,
          zoom: 12,
          bounds: { north: 19.00, south: 18.65, east: 99.15, west: 98.80 },
          image: '/assets/cities/thailand_chiangmai.webp',
          credit: 'Tha Phae Gate, Chiang Mai (CC BY-SA 3.0) – Wikimedia Commons'
        },
        {
          name: '푸켓',
          lat: 7.8804,
          lng: 98.3923,
          zoom: 12,
          bounds: { north: 8.10, south: 7.70, east: 98.55, west: 98.25 },
          image: '/assets/cities/thailand_phuket.webp',
          credit: 'The Big Buddha, Phuket (CC BY-SA 4.0) – Wikimedia Commons'
        },
        {
          name: '파타야',
          lat: 12.9236,
          lng: 100.8825,
          zoom: 12,
          bounds: { north: 13.05, south: 12.80, east: 101.05, west: 100.70 },
          image: '/assets/cities/thailand_pattaya.webp',
          credit: 'Sanctuary of Truth, Pattaya (CC BY-SA 4.0) – Wikimedia Commons'
        },
        {
          name: '끄라비',
          lat: 8.0863,
          lng: 98.9063,
          zoom: 12,
          bounds: { north: 8.25, south: 7.95, east: 99.05, west: 98.75 },
          image: '/assets/cities/thailand_krabi.webp',
          credit: 'Railay Beach (CC BY 2.0) – Wikimedia Commons'
        }
      ]
    }
  };

  const handleCountryClick = (countryKey) => setSelectedCountry(countryKey);
  const handleCityClick = (city) => onSelectCity(city);
  const handleBack = () => setSelectedCountry(null);

  const CreditLine = ({ credit }) => {
    if (!credit) return null;
    return (
      <div
        style={{
          position: "absolute",
          left: 12,
          right: 12,
          bottom: 10,
          fontSize: "11px",
          color: "rgba(255,255,255,0.75)",
          textShadow: "1px 1px 2px rgba(0,0,0,0.7)",
          background: "rgba(0,0,0,0.2)",
          padding: "4px 8px",
          borderRadius: "8px",
        }}
      >
        {credit}
      </div>
    );
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {!selectedCountry ? (
        <div style={{ maxWidth: "600px", width: "100%" }}>
          <div
            style={{
              textAlign: "center",
              marginBottom: "40px",
              color: "white",
            }}
          >
            <h1
              style={{
                fontSize: "42px",
                marginBottom: "10px",
                fontWeight: "bold",
              }}
            >
              🍜 맛집 지도
            </h1>
            <p style={{ fontSize: "18px", opacity: 0.9 }}>
              여행할 나라를 선택해주세요
            </p>
          </div>

          {Object.entries(countries).map(([key, country]) => (
            <div
              key={key}
              onClick={() => handleCountryClick(key)}
              style={{
                marginBottom: "20px",
                borderRadius: "20px",
                overflow: "hidden",
                cursor: "pointer",
                transition: "transform 0.3s, box-shadow 0.3s",
                boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
                position: "relative",
                height: "180px",
                backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${country.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 50px rgba(0,0,0,0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 40px rgba(0,0,0,0.2)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: "60px", marginBottom: "10px" }}>
                  {country.flag}
                </div>
                <h2
                  style={{
                    fontSize: "32px",
                    margin: 0,
                    fontWeight: "bold",
                    textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
                  }}
                >
                  {country.name}
                </h2>
              </div>

              <CreditLine credit={country.credit} />
            </div>
          ))}
        </div>
      ) : (
        <div style={{ maxWidth: "600px", width: "100%" }}>
          <button
            onClick={handleBack}
            style={{
              background: "rgba(255,255,255,0.2)",
              border: "none",
              color: "white",
              fontSize: "18px",
              cursor: "pointer",
              marginBottom: "30px",
              display: "flex",
              alignItems: "center",
              padding: "12px 20px",
              borderRadius: "12px",
              backdropFilter: "blur(10px)",
            }}
          >
            ← 뒤로 가기
          </button>

          <div
            style={{
              textAlign: "center",
              marginBottom: "40px",
              color: "white",
            }}
          >
            <h2
              style={{
                fontSize: "36px",
                marginBottom: "10px",
                fontWeight: "bold",
              }}
            >
              {countries[selectedCountry].flag}{" "}
              {countries[selectedCountry].name}
            </h2>
            <p style={{ fontSize: "18px", opacity: 0.9 }}>
              방문할 도시를 선택해주세요
            </p>
          </div>

          {countries[selectedCountry].cities.map((city) => (
            <div
              key={city.name}
              onClick={() => handleCityClick(city)}
              style={{
                marginBottom: "20px",
                borderRadius: "20px",
                overflow: "hidden",
                cursor: "pointer",
                transition: "transform 0.3s, box-shadow 0.3s",
                boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
                position: "relative",
                height: "160px",
                backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${city.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 50px rgba(0,0,0,0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 40px rgba(0,0,0,0.2)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <h3
                  style={{
                    fontSize: "48px",
                    margin: 0,
                    fontWeight: "bold",
                    textShadow: "3px 3px 6px rgba(0,0,0,0.8)",
                    letterSpacing: "2px",
                  }}
                >
                  {city.name}
                </h3>
              </div>

              <CreditLine credit={city.credit} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountrySelector;
